import axios from './axiosInstances/axiosInstance';

export const createUser = (data, basketId, config) => {
  return axios.post('/users', { ...data, ...(basketId && { basketid: basketId }) }, config);
};
